import {
  Typography,
  TypographyMods,
  TypographySizes,
} from '@vk-cloud-solutions/marketing-ui';
import classNames from 'classnames';
import Link from 'next/link';
import { useMemo } from 'react';

import { NextImage } from '~components/NextImage/NextImage';

import styles from './ServiceLabel.module.scss';
import { ServiceLabelMods, ServiceLabelProps } from './ServiceLabel.types';

export function ServiceLabel({
  className,
  mods,
  href,
  title,
  images,
}: ServiceLabelProps) {
  const hasImages = images.black && images.blue && images.white;

  const imageProps = useMemo(() => {
    if (!hasImages) {
      return undefined;
    }

    if (mods?.includes(ServiceLabelMods.Dark)) {
      return images.white;
    }

    return images.black;
  }, [mods, hasImages, images.black, images.white]);

  if (href) {
    return (
      <Link href={href} title={title}>
        <a
          target="_blank"
          className={classNames(
            styles.wrapper,
            styles.link,
            className,
            mods?.map((mod) => styles[mod]),
          )}
        >
          {hasImages && (
            <span className={styles.image}>
              {imageProps && <NextImage {...imageProps} alt={title} />}
              {images.blue && <NextImage {...images.blue} alt={title} />}
            </span>
          )}
          <Typography
            tagName={TypographySizes.span}
            mods={[TypographyMods.captionS]}
            className={styles.title}
          >
            {title}
          </Typography>
        </a>
      </Link>
    );
  }

  return (
    <div
      className={classNames(
        styles.wrapper,
        className,
        mods?.map((mod) => styles[mod]),
      )}
    >
      <span className={styles.image}>
        {imageProps && (
          <NextImage {...imageProps} className={styles.img} alt={title} />
        )}
      </span>
      <Typography
        tagName={TypographySizes.span}
        mods={[TypographyMods.captionS]}
        className={styles.title}
      >
        {title}
      </Typography>
    </div>
  );
}
